import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const TestimonialCarousel = ({ testimonials }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  if (testimonials.length === 0) {
    return (
      <div className="text-center py-12">
        <h4 className="text-xl font-semibold mb-4">No testimonials available</h4>
        <p className="text-gray-600">Be the first to share your experience with us!</p>
      </div>
    );
  }

  const current = testimonials[currentIndex];

  return (
    <div className="relative">
      <div className="bg-gray-50 rounded-2xl p-8 md:p-12 shadow-lg max-w-4xl mx-auto text-center">
        <p className="text-lg md:text-xl text-gray-700 mb-6 italic">
          "{current.text}"
        </p>
        <h6 className="text-sm font-semibold text-gray-600 mb-4">
          {current.title}
        </h6>
        <div>
          <p className="font-bold text-gray-900">{current.name}</p>
          <p className="text-sm text-gray-500">{current.date}</p>
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-center items-center gap-4 mt-8">
        <button
          onClick={prevTestimonial}
          className="bg-yellow-400 text-gray-900 p-3 rounded-full hover:bg-yellow-500 transition-all hover:scale-110 shadow-lg"
          aria-label="Previous testimonial"
        >
          <ChevronLeft size={24} />
        </button>
        <div className="flex gap-2">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                index === currentIndex ? 'bg-yellow-400 w-8' : 'bg-gray-300'
              }`}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
        <button
          onClick={nextTestimonial}
          className="bg-yellow-400 text-gray-900 p-3 rounded-full hover:bg-yellow-500 transition-all hover:scale-110 shadow-lg"
          aria-label="Next testimonial"
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
};

export default TestimonialCarousel;
